import { Box, Text } from '@chakra-ui/react';
import { AUDIO_TRACK_CONTAINER_ID, AUDIO_TRACK_ID } from './constants';
import { audioPlayerTrackSx } from './styles';

interface AudioPlayerTrackProps {
  duration: number;
  isLoadingAudio: boolean;
  src?: string;
  isError?: boolean;
}

export const AudioPlayerTrack = ({
  duration,
  isLoadingAudio,
  src,
  isError,
}: AudioPlayerTrackProps) => {
  const styles = audioPlayerTrackSx({
    isLoading: isLoadingAudio || isError || !duration,
  });

  return (
    <Box id={AUDIO_TRACK_CONTAINER_ID} sx={styles.audioTrack}>
      <audio id={AUDIO_TRACK_ID} src={src}>
        <track src="" kind="captions" label="song" />
      </audio>
      {isError && (
        <Text sx={styles.error} data-testid="audio-error">
          There was a problem loading file
        </Text>
      )}
    </Box>
  );
};
